import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { NODE_ENV } from 'const';
import en from './en';
import ru from './ru';
i18next
    .use(initReactI18next)
    .init({
    fallbackLng: 'en',
    lng: window.localStorage.getItem('lang') || 'en',
    debug: NODE_ENV === 'development',
    supportedLngs: ['en', 'ru'],
    load: 'all',
    resources: { en, ru },
});
